(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/last-searched/assets/javascripts/last-searched.js') >= 0) return;  svs.modules.push('/components/casino/last-searched/assets/javascripts/last-searched.js');
"use strict";


const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const logger = svs.core.log.getLogger('components:casino:last-searched');
const {
  isValidCardName
} = svs.components.casino_react.common.utils;
const {
  CasinoPreferenceNames,
  putPreference,
  isCloudPreferencesEnabled
} = svs.components.casino.preferences;
const putLastSearchedClient = async lastSearchedList => {
  if (!isLoggedIn) {
    return;
  }
  const validItems = lastSearchedList.filter(item => isValidCardName(item));
  try {
    if (isCloudPreferencesEnabled()) {
      await putPreference({
        name: CasinoPreferenceNames.LAST_SEARCHED,
        values: validItems
      });
    } else {
      await svs.core.jupiter.callAsync({
        method: 'PUT',
        path: "/casino/1/lastsearched?lastsearched=".concat(validItems.join(';'))
      });
    }
  } catch (error) {
    logger.warn('Failed to update last searched', error);
  }
};
setGlobal('svs.components.casino.lastSearched.putLastSearchedClient', putLastSearchedClient);

 })(window);